import { Box, BoxProps, Text } from 'grommet';
import { Alert, Checkmark, Update } from 'grommet-icons';
import { PropsWithChildren } from 'react';
import { Blink } from './Blink';

export enum SaveStatus {
  Saving = 'saving',
  Unsaved = 'unsaved',
  Saved = 'saved',
  Error = 'error',
}

export type SaveStatusIndicatorProps = {
  saveStatus?: SaveStatus;
  boxProps?: BoxProps;
};

export const SaveStatusIndicator = ({ saveStatus, boxProps }: SaveStatusIndicatorProps) => {
  if (!saveStatus) return null;

  const Container = ({ children }: PropsWithChildren) => (
    <Box direction="row" gap="xsmall" align="center" margin={{ left: 'medium' }} {...boxProps}>
      {children}
    </Box>
  );

  switch (saveStatus) {
    case SaveStatus.Saved:
      return (
        <Container>
          <Checkmark size="10px" color="status-ok" />
          <Text size="xsmall" color="status-ok" weight={500}>
            <i>All changes saved</i>
          </Text>
        </Container>
      );
    case SaveStatus.Error:
      return (
        <Container>
          <Alert size="10px" color="status-error" />
          <Text size="xsmall" color="status-error" weight={500}>
            <i>Error saving changes</i>
          </Text>
        </Container>
      );
    default:
      return (
        <Blink speed={750}>
          <Container>
            {/* <IndicatorCircle color="brand" /> */}
            <Box animation={{ type: 'rotateRight', size: 'small' }}>
              <Update size="10px" color="brand" />
            </Box>
            <Text size="xsmall" color="brand" weight={500}>
              <i>Saving changes...</i>
            </Text>
          </Container>
        </Blink>
      );
  }
};
